// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__W1TTO","btn--solid":"Button_btn--solid__vkK4K","btn--outline":"Button_btn--outline__4mEzg"};